export const doesBrowserSupportContainerQuery = CSS.supports && CSS.supports('container-type', 'inline-size');
